<template>
  <div
    :class="[
      'ss__custom__header__menu__wrapper',
      {'ss__custom__header__menu__wrapper--visible': visible}
    ]">
    <SsButton2 type="text" @click="toggleVisible" class="ss__custom__header__menu__btn__toogle">
      <transition name="btn__fade" mode="out-in">
        <i v-if="!visible" class="ssCommunityIcon__menu" key="menu"/>
        <i v-else class="ssCommunityIcon__cancel" key="cancel"/>
      </transition>
    </SsButton2>
  </div>
</template>

<script>
import SsButton2 from '../../../SsButton2'
export default {
  name: 'SsCustomHeaderMobileMenu',

  components: {
    SsButton2
  },

  props: {
    menu: {
      type: Array,
      default: () => ([])
    },
    visible: Boolean
  },

  data () {
    return {
      // visible: false,
      preventScroll: false
    }
  },

  watch: {
  },

  methods: {
    toggleVisible () {
      if (this.visible) {
        this.close()
      } else {
        this.open()
      }
    },
    open () {
      this.$emit('update:visible', true)
      setTimeout(() => {
        document.body.addEventListener('click', this.close)
      }, 300)
    },
    close () {
      this.$emit('update:visible', false)
      document.body.removeEventListener('click', this.close)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/media.styl'
.ss__custom__header__menu__wrapper {
  .ss__custom__header__menu__btn__toogle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--w-ssCustonHeaderBtnMenu, 32px);
    height: var(--h-ssCustonHeaderBtnMenu, 32px);
    i {
      font-size: var(--size-ssCustonHeaderBtnMenu, 20px);
      color: var(--color-ssCustonHeaderBtnMenu, var(--B8-t));
    }
    .btn__fade-enter-active,
    .btn__fade-leave-active {
      opacity: 1;
      transition: opacity  0s $a-func-default;
    }
    .btn__fade-enter,
    .btn__fade-leave-to {
      opacity: 0;
    }
  }
}
.ss__custom__header__menu__wrapper--visible {
  .btn__toogle__menu {
    z-index: 2;
  }
  .ss__header__phone__menu {
    z-index: 1;
  }
}
</style>
